import { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import {Home} from "./pages/home";
// import {Auth} from "./pages/auth";
import {Login} from "./pages/auth";
import {Register} from "./pages/auth";
import {NewPost} from "./pages/new-post";
import {MyPosts} from "./pages/my-posts";
import {Navbar} from "./components/Navbar/navbar";
import {Landing} from "./pages/landing";
import {SavedPosts} from "./pages/saved-posts";
import {EditPost} from "./pages/edit-post";
import { ResetPassword } from './pages/ResetPassword';
import AlertsContainer from './components/Alert/AlertsContainer';
import FeedbackButton from './components/FeedbackButton/FeedbackButton';

import './App.css';
import { AppContext } from './AppContext';

const AuthRouter = ({ element }) => {
  const { isLoggedIn } = useContext(AppContext);

  return isLoggedIn ? element : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <AlertsContainer />
        <Routes>
          <Route path = "/home" element = {<Home />} />
          
          <Route path = "/login" element = {<Login />} />
          <Route path = "/register" element = {<Register />} />
          <Route path = "/" element = {<Landing />} />
          
          <Route path = "/new-post" element = {<AuthRouter element={<NewPost/>}></AuthRouter>} />
          <Route path = "/my-posts" element = {<AuthRouter element={<MyPosts/>}></AuthRouter>} />
          <Route path = "/saved-posts" element = {<AuthRouter element={<SavedPosts/>}></AuthRouter>}/>
          <Route path="/edit-post/:id" element={<AuthRouter element={<EditPost />}></AuthRouter>} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
        </Routes>
        <FeedbackButton />
      </Router>
    </div>
  );
}

export default App;